module.exports = __webpack_public_path__ + "img/9.27f88c63.png";